import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import axios from "axios";
import "./css/policy.css";
import "./css/app.css";
import ReactMarkdown from 'react-markdown';
import home from "./assets/images/home.png";
import Footer from "./partials/Footer";
import KashimaIcon from "./assets/images/kashima.png";

export default function Policy() {
    const [faq, setFaq] = useState(``);

    useEffect(() => {
        updateFaq()
    }, [])

    async function updateFaq() {
        const {
            data,
            status
        } = await axios.get("https://raw.githubusercontent.com/Deivu/Kashima/master/assets/privacy_policy.md");
        if (status !== 200) return;
        return setFaq(data);
    }


    return (<>
        <div className="header">
            <div className="header-content">
                <div className="header-application-name">
                    <img className="header-content-logo"
                         src={KashimaIcon}
                         alt="Kashima"/>
                    <p className="header-content-name">Kashima</p>
                </div>
                <div className="header-search-bar">
                </div>
                <Link to="/" className="header-buttons">
                    <img src={home} alt="Home"/>
                </Link>
            </div>
        </div>
        <div className="main-section faq-main-section">
            <div className="faq-title policy-title">
                <p>Privacy Policy</p>
                <div className="policy-content">
                    <ReactMarkdown>{faq ? faq : "**Loading...**"}</ReactMarkdown>
                </div>
            </div>
        </div>
        <Footer/>
    </>)
}